import type { ApolloError } from '@apollo/client';

import { isGraphQLAuthError } from 'src/modules/error-handling/error-handling';
import type { Location } from 'src/types';

import { Actions, type NextRoleAction } from './reducer';

export const updateApproachability = ({
  approachable,
}: {
  approachable: boolean;
}): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_APPROACHABILITY_START,
  payload: { approachable },
});

export const updateApproachabilitySuccess = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_APPROACHABILITY_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const updateApproachabilityFailure = (
  error: ApolloError,
): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_APPROACHABILITY_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const updateWorkTypes = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_WORKTYPE_START,
});

export const updateWorkTypesSuccess = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_WORKTYPE_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const updateWorkTypesFailure = (error: ApolloError): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_WORKTYPE_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const selectAvailability = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_AVAILABILITY_START,
});

export const selectAvailabilitySuccess = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_AVAILABILITY_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const selectAvailabilityFailure = (
  error: ApolloError,
): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_AVAILABILITY_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const updateNextRoleRightToWork = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_RTW_START,
});

export const updateNextRoleSalary = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_SALARY_START,
});

export const updateNextRoleRightToWorkSuccess = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_RTW_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const updateNextRoleSalarySuccess = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_SALARY_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const updateNextRoleRightToWorkFailure = (
  error: ApolloError,
): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_RTW_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const updateNextRoleSalaryFailure = (
  error: ApolloError,
): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_SALARY_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const updateLocations = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_LOCATIONS_START,
});

export const updateLocationsSuccess = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_LOCATIONS_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const updateLocationsFailure = (error: ApolloError): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_LOCATIONS_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const removeLocationFrom = (
  { id, subLocation: { id: subLocationId } }: Location,
  locations: Location[],
): Location[] =>
  locations.filter(
    (loc) =>
      !(subLocationId
        ? loc.id === id && loc.subLocation.id === subLocationId
        : loc.id === id),
  );

export const selectClassification = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_CLASSIFICATION_START,
});

export const selectClassificationSuccess = (): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_CLASSIFICATION_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const selectClassificationFailure = (
  error: ApolloError,
): NextRoleAction => ({
  type: Actions.NEXT_ROLE_UPDATE_CLASSIFICATION_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});
